import { createSelector } from "@reduxjs/toolkit";

const localizationSlice = state => state.localization

export const selectPublicPagePreferredLanguage = createSelector(
  localizationSlice,
  localization => localization.publicPagePreferredLanguage
)
export const selectBrowserLanguage = createSelector(
  localizationSlice,
  localization => localization.browserLanguage
)